module.exports = __webpack_public_path__ + "img/ico-grapes.b253a82f.svg";